export default function contains(root, n) {
    if (!root) {
        return false;
    }
    // Use native if support
    if (root.contains && n) {
        return root.contains(n);
    }
    // `document.contains` not support with IE11
    let node = n;
    while (node) {
        if (node === root) {
            return true;
        }
        node = node.parentNode || undefined;
    }
    return false;
}
